module.exports = __webpack_public_path__ + "img/thumbnail_WildBoar_j_normal.2cf7e017.png";